// extracted by mini-css-extract-plugin
module.exports = {"Tabs__body":"Tabs_Tabs__body__2d3xS"};